"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecondaryCta() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return;
}